import { connect } from "react-redux";
import { injectIntl } from "react-intl";

import { getIsExpanded, analysisActions, getActiveModule } from "~/action-panel";
import { updateFieldInfo } from "~/action-panel/components/field-module/actions";
import {
    getIsFieldInit,
    getIsNewField,
    getFieldInfoModel,
    getFieldBoundaryOverlapAction,
    getFieldBoundaryTransferGeometries,
    getIsFieldBoundaryTransferOpen,
} from "~/action-panel/components/field-module/selectors";
import { importWizardSelectors } from "~/action-panel/components/import-module";
import { getTheUserGuid } from "~/login";
import { getUser, getTheSystemName } from "~/login/selectors";
import { actions as notificationActions } from "~/notifications";
import {
    actions as recsEventsActions,
    analysisSelectors,
    eventsSelectors,
    recsSelectors,
    selectors as recsEventsSelectors,
} from "~/recs-events";
import { actions as fieldActions } from "~/action-panel/components/field-module";
import { Toolset } from "@ai360/core";

import * as actions from "../actions";
import { MapTools } from "../components/map-tools.4x";
import * as selectors from "../selectors";
import * as eventListSelectors from "~/action-panel/components/event-module/components/event-list/selectors";
import * as mapActions from "../../map-control/actions";
import * as mapSelectors from "../../map-control/selectors";
import * as nonFieldFeatureInformationActions from "~/action-panel/components/layer-module/components/non-field-feature-information/actions";
import {
    getEventFieldBoundaryGraphics,
    getIsCopyEventAction,
} from "~/recs-events/events/selectors";
import { getIsCopyRecAction, getRecFieldBoundaryGraphics } from "~/recs-events/recs/selectors";
import * as eventListActions from "~/action-panel/components/event-module/components/event-list/actions";
import { actions as unitActions, selectors as unitSelectors, unitNames } from "~/core/units";
import { mapToolsActions } from "~/map";
import { onUpdateZoneGridOptions } from "../actions";

const { getUnitCode, UNIT_AREA, UNIT_LENGTH } = unitNames;

const mapStateToProps = (state) => {
    const isCopyEventAction = getIsCopyEventAction(state);
    const isCopyRecAction = getIsCopyRecAction(state);
    const eventFieldBoundaryGraphics = getEventFieldBoundaryGraphics(state);
    const recFieldBoundaryGraphics = getRecFieldBoundaryGraphics(state);
    const activeToolset = selectors.getActiveToolset(state);
    const toolsetPayload = selectors.getToolsetPayload(state);
    const eventGuidToEventSummaryMap = eventsSelectors.getEventGeneralGuidToEventSummaryMap(state);
    const fieldGuid =
        activeToolset !== Toolset.ZONE_EDIT &&
        activeToolset !== Toolset.ZONE_COPY &&
        activeToolset !== Toolset.SAMPLING &&
        activeToolset !== Toolset.SCOUTING_ZONE_EDIT &&
        activeToolset !== Toolset.ANALYSIS
            ? null
            : toolsetPayload && toolsetPayload.field && toolsetPayload.field.fieldGuid;
    const areaIdToHasDataMap =
        eventsSelectors.getEventAreaIdToHasDataMap(state, fieldGuid) ||
        recsSelectors.getRecAreaIdToHasDataMap(state, fieldGuid) ||
        analysisSelectors.getManagementAreaIdToHasDataMap(state, fieldGuid) ||
        new Map();
    const { copyZonesFromToMap, fieldGuidToCurrentAreaId } =
        recsEventsSelectors.getZonesState(state);
    const currentAreaId = fieldGuidToCurrentAreaId.get(fieldGuid);
    const {
        selectedSamplePointGuidIdSet,
        gridOrientationSettings,
        gridStandardUnitSettings,
        soilSampleResults,
        tissueSampleResults,
        fieldGuidToEventDetails,
    } = eventsSelectors.getModuleState(state);
    const { fieldGuidToRecDetails } = recsSelectors.getModuleState(state);
    const recEventDetails = fieldGuidToEventDetails.has(fieldGuid)
        ? fieldGuidToEventDetails.get(fieldGuid)
        : fieldGuidToRecDetails.get(fieldGuid);

    return {
        actionPanelModule: getActiveModule(state),
        actionPanelIsExpanded: getIsExpanded(state),
        activeMapTool: selectors.getActiveMapTool(state),
        activeToolset,
        activeType: selectors.getActiveType(state),
        areaIdToHasDataMap,
        areaUnits: selectors.getAreaUnits(state),
        batchReset: selectors.getBatchReset(state),
        bufferOptions: selectors.getBufferOptions(state),
        bufferReady: selectors.getBufferReady(state),
        chosePortalBoundary: selectors.getChosePortalBoundary(state),
        copyZonesFromToMap,
        currentAreaId,
        currentFieldEditGeometries: selectors.getFieldEditGeometries(state),
        currentProcessCounts: selectors.getCurrentProcessCounts(state),
        defaultZoneUserGridSettings: selectors.defaultZoneUserGridSettings(state),
        eventGuidToEventSummaryMap,
        fieldModel: getFieldInfoModel(state),
        fieldBoundaryGraphics: eventFieldBoundaryGraphics || recFieldBoundaryGraphics,
        fieldBoundaryOverlapAction: getFieldBoundaryOverlapAction(state),
        fieldBoundaryTransferModalOpen: getIsFieldBoundaryTransferOpen(state),
        fieldBoundaryTransferGeometries: getFieldBoundaryTransferGeometries(state),
        generatedShrinkwrappedBoundary: selectors.getGeneratedShrinkwrappedBoundary(state),
        gridOrientationSettings: gridOrientationSettings,
        gridRemoveFlag: selectors.getGridRemoveFlag(state),
        importFieldList: importWizardSelectors.getImportFieldList(state),
        isCopyAction: isCopyEventAction || isCopyRecAction,
        isEquationRec: recsSelectors.getIsEquationRec(state),
        isEquationRecProcessing: recsSelectors.getIsEquationRecProcessing(state),
        isFieldInitializing: getIsFieldInit(state),
        isFromEquationRec: eventsSelectors.getIsFromEquationRec(state),
        isUsingImportWizard: importWizardSelectors.getImportFileGuidList(state).length > 0,
        isImportedEventRec:
            eventsSelectors.getIsImported(state) || recsSelectors.getIsImported(state),
        isNewEventRec: recsEventsSelectors.getIsNewEventRec(state),
        isNewField: getIsNewField(state),
        isPointData: importWizardSelectors.getIsPointData(state),
        isProcessing: selectors.getToolsProcessing(state),
        jdFallbackFieldEditGeometries: selectors.getJdFallbackFieldEditGeometries(state),
        lengthUnits: selectors.getLengthUnits(state),
        lockBoundary: getFieldInfoModel(state).lockBoundary,
        recEventDetails,
        samplingEvent: eventsSelectors.getSampleAgEvent(state, fieldGuid),
        samplingGridSettings: gridStandardUnitSettings,
        samplingViewOnly: soilSampleResults != null || tissueSampleResults != null,
        selectedSites: selectedSamplePointGuidIdSet,
        shouldZoomToField: eventListSelectors.getShouldZoomToField(state),
        systemName: getTheSystemName(state),
        toolsetDisabled: selectors.getToolsetDisabled(state),
        toolsetPayload,
        traceApplyFlag: selectors.getTraceApplyFlag(state),
        traceResetFlag: selectors.getTraceResetFlag(state),
        unitOptionsArea: unitSelectors.getUnitPicklistOptionsFromCode(
            state,
            getUnitCode(UNIT_AREA)
        ),
        unitOptionsLength: unitSelectors.getUnitPicklistOptionsFromCode(
            state,
            getUnitCode(UNIT_LENGTH)
        ),
        userGuid: getTheUserGuid(state),
        userInfo: getUser(state),
        userHasJdPortalAccess: selectors.getUserJdPortalAccess(state),
        visibleToolbarMenuDimensions: selectors.getVisibleToolbarMenuDimensions(state),
        zoneGridOptions: selectors.getZoneGridOptions(state),
        zoneGridOrientationSettings: selectors.getZoneGridOrientationSettings(state),
        zoneGridSettings: selectors.getZoneGridStandardUnitSettings(state),
        zoom: mapSelectors.getZoomLevel(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    onAddZone: (fieldGuid, eventTypeName, eventAreaId, currentAreaId, calculatedArea, shape) =>
        dispatch(
            recsEventsActions.addArea(
                fieldGuid,
                eventTypeName,
                eventAreaId,
                currentAreaId,
                calculatedArea,
                shape
            )
        ),
    onAddFieldToJdOps: (geometriesForAddToJdOps, fieldModel, companyGuid, customerGuid, userGuid) =>
        dispatch(
            fieldActions.addFieldToJdOps(
                geometriesForAddToJdOps,
                fieldModel,
                companyGuid,
                customerGuid,
                userGuid
            )
        ),
    onClearRemoveGridFlag: () => dispatch(actions.setRemoveGridFlag(false)),
    onClearTraceFlags: () => dispatch(actions.clearTraceFlags()),
    onFetchDefaultZoneUserGridSettings: () => dispatch(actions.fetchDefaultZoneUserGridSettings()),
    onFetchDefaultZoneUserGridSettingsSucceed: (defaultSettings) =>
        dispatch(actions.fetchDefaultZoneUserGridSettingsSucceed(defaultSettings)),
    onFetchUnits: (units) => dispatch(unitActions.fetchUnitData(units)),
    onFieldBoundaryOverlapDetected: () => dispatch(fieldActions.fieldBoundaryOverlapDetected()),
    onLinkFieldWithJdOps: (
        fieldModel,
        jdFieldId,
        fieldNameInJd,
        companyGuid,
        customerGuid,
        userGuid
    ) =>
        dispatch(
            fieldActions.linkFieldWithJdOps(
                fieldModel,
                jdFieldId,
                fieldNameInJd,
                companyGuid,
                customerGuid,
                userGuid
            )
        ),
    onLockedBoundaryDetected: () => dispatch(fieldActions.lockedBoundaryOverlapDetected()),
    onPushToasterMessage: (message, type, values, autoClose = true) =>
        dispatch(notificationActions.pushToasterMessage(message, type, values, autoClose)),
    onPushToasterMessageDirect: (message, type, autoClose) =>
        dispatch(notificationActions.pushToasterMessage(message, type, null, autoClose)),
    onResetClassifiedZones: (fieldGuid, areaIdToPolygonMap, areaIdToClassBreaksMap) =>
        dispatch(
            recsEventsActions.resetClassifiedAreaPolygons(
                fieldGuid,
                areaIdToPolygonMap,
                areaIdToClassBreaksMap
            )
        ),
    onResetShouldZoomToField: (shouldZoomToField) =>
        dispatch(eventListActions.resetShouldZoomToField(shouldZoomToField)),
    onResetZones: (fieldGuid, areaIdToPolygonMap) =>
        dispatch(recsEventsActions.resetAreaPolygons(fieldGuid, areaIdToPolygonMap)),
    onRestoreAreaList: (fieldGuid, restoreId) =>
        dispatch(recsEventsActions.restoreAreaList(fieldGuid, restoreId)),
    onSaveAreaList: (fieldGuid, restoreId) =>
        dispatch(recsEventsActions.saveAreaList(fieldGuid, restoreId)),
    onSetActiveMapTool: (tool) => dispatch(actions.setActiveMapTool(tool)),
    onSetActiveToolsetOnly: (toolset) => dispatch(actions.setActiveToolsetOnly(toolset)),
    onSetActiveZone: (fieldGuid, areaId) =>
        dispatch(recsEventsActions.setCurrentAreaId(fieldGuid, areaId)),
    onSetAreaIsIncluded: (fieldGuid, areaId, isIncluded) =>
        dispatch(recsEventsActions.setAreaIsIncluded(fieldGuid, areaId, isIncluded)),
    onGetUserHasJdPortalAccess: (orgLevelGuid, customerGuid) =>
        dispatch(actions.getUserJdPortalAccess(orgLevelGuid, customerGuid)),
    onSetBatchReset: (batchReset) => dispatch(actions.setBatchReset(batchReset)),
    onSetBufferOptions: (options) => dispatch(actions.setBufferOptions(options)),
    onSetBufferReady: (ready) => dispatch(actions.setBufferReady(ready)),
    onSetCanClip: (canClip) => dispatch(actions.setCanClip(canClip)),
    onSetCanClipPending: (pending) => dispatch(actions.setCanClipPending(pending)),
    onSetChosePortalBoundary: (chosePortalBoundary) =>
        dispatch(actions.setChosePortalBoundary(chosePortalBoundary)),
    onSetCopyToAreaIdSet: (areaIdSet) => dispatch(recsEventsActions.setCopyToAreaIdSet(areaIdSet)),
    onSetFieldBoundaryImportFileGuid: (importFileGuid) =>
        dispatch(fieldActions.setFieldBoundaryImportFileGuid(importFileGuid)),
    onSetFieldEditGeometries: (geometry) => dispatch(actions.setFieldEditGeometries(geometry)),
    onSetGeneratedShrinkwrappedBoundary: (generatedShrinkwrappedBoundary) =>
        dispatch(actions.setGeneratedShrinkwrappedBoundary(generatedShrinkwrappedBoundary)),
    onSetJdFallbackFieldEditGeometries: (geometry) =>
        dispatch(actions.setJdFallbackFieldEditGeometries(geometry)),
    onSetFieldBoundariesToClip: (fieldBoundaries) =>
        dispatch(fieldActions.setFieldBoundariesToClip(fieldBoundaries)),
    onSetFieldBoundaryTransferGeometries: (geometries) =>
        dispatch(fieldActions.setFieldBoundaryTransferGeometries(geometries)),
    onSetFieldBoundaryTransferModalOpen: (isOpen) =>
        dispatch(fieldActions.setFieldBoundaryTransferModalOpen(isOpen)),
    onSetIsZoneEliminateModalOpen: (isOpen) =>
        dispatch(actions.setIsZoneEliminateModalOpen(isOpen)),
    onSetIsZoneGridModalOpen: (isOpen) => dispatch(actions.setIsZoneGridModalOpen(isOpen)),
    onSetFieldInfoForUnarchive: (fieldId, fieldName) =>
        dispatch(fieldActions.setFieldInfoForUnarchive(fieldId, fieldName)),
    onSetPortalBoundarySyncModalOpen: (isOpen) =>
        dispatch(fieldActions.setPortalBoundarySyncModalOpen(isOpen)),
    onSetShouldUseExistingJdClient: (shouldUseExistingJdClient) =>
        dispatch(fieldActions.setShouldUseExistingJdClient(shouldUseExistingJdClient)),
    onSetAddOrUnarchiveBoundaryInPortalModalOpen: (isOpen, clientExists) =>
        dispatch(fieldActions.setAddOrUnarchiveBoundaryInPortalModalOpen(isOpen, clientExists)),
    onSetIsAddOrIsUnarchive: (isAddOrIsUnarchive) =>
        dispatch(fieldActions.setIsAddOrIsUnarchive(isAddOrIsUnarchive)),
    onSetCenterAndZoomForBoundarySyncModal: (latitude, longitude, zoomLevel, fieldPolygons) =>
        dispatch(
            fieldActions.setCenterAndZoomForBoundarySyncModal(
                latitude,
                longitude,
                zoomLevel,
                fieldPolygons
            )
        ),
    onSetPerfectlyMatchedJdFieldName: (fieldName) =>
        dispatch(fieldActions.setPerfectlyMatchedJdFieldName(fieldName)),
    onSetJdBoundariesForBoundarySyncModal: (overlaps, names) =>
        dispatch(fieldActions.setJdBoundariesForBoundarySyncModal(overlaps, names)),
    onSetMinMaxGridCell: (minAreaAcres, maxAreaAcres) =>
        dispatch(recsEventsActions.setGridMinMaxArea(minAreaAcres, maxAreaAcres)),
    onSetMapIsLoading: (isLoading) => dispatch(mapActions.setIsLoading(isLoading)),
    onSetNonFieldFeatureInformationFeatureGeometries: (geometries) =>
        dispatch(nonFieldFeatureInformationActions.setFeatureGeometries(geometries)),
    onSetGridOrientationSettings: (settings) =>
        dispatch(recsEventsActions.setGridOrientationSettings(settings)),
    onSetZoneGridOrientationSettings: (settings) =>
        dispatch(mapToolsActions.setZoneGridOrientationSettings(settings)),
    onSetSamplePoints: (samplePoints) =>
        dispatch(recsEventsActions.setEventSamplePoints(samplePoints)),
    onSetSelectedSamplePoints: (guidSet) =>
        dispatch(recsEventsActions.setSelectedSamplePoints(guidSet)),
    onSetShrinkwrapBounds: (geometry) => dispatch(actions.generateProposedBoundary(geometry)),
    onSetToolsetDisabled: (disabled) => dispatch(actions.setToolsetDisabled(disabled)),
    onSetToolsProcessing: (isProcessing) => dispatch(actions.setToolsProcessing(isProcessing)),
    onSetTraceCounts: (traceCompleteCount, totalCount, traceSites) =>
        dispatch(recsEventsActions.setTraceCounts(traceCompleteCount, totalCount, traceSites)),
    onSetTraceSites: (traceSites) => dispatch(recsEventsActions.setTraceSites(traceSites)),
    onSetVisibleToolbarMenuDimensions: (dimensions) =>
        dispatch(actions.setVisibleToolbarMenuDimensions(dimensions)),
    onSetZoneFileGuid: (fieldGuid, importFileGuid) =>
        dispatch(recsEventsActions.setZoneFileGuid(fieldGuid, importFileGuid)),
    onSetZonesLoading: (loading) => dispatch(recsEventsActions.setZonesLoading(loading)),
    onUpdateAnalysisZones: (zones, fieldBoundaryGuid, zonesMap) =>
        dispatch(analysisActions.updateZones(zones, fieldBoundaryGuid, zonesMap)),
    onUpdateZoneGridOptions: (zoneGridSettings) =>
        dispatch(onUpdateZoneGridOptions(zoneGridSettings)),
    onUpdateZones: (fieldGuid, zonesMap, isEliminate) =>
        dispatch(recsEventsActions.updateAreaPolygons(fieldGuid, zonesMap, isEliminate)),
    setZoomToNonFieldFeatures: (features) =>
        dispatch(mapActions.setZoomToNonFieldFeatures(features)),
    setZoomToField: (fieldGuid) => dispatch(mapActions.setZoomToField(fieldGuid)),
    updateFieldModel: (f) => dispatch(updateFieldInfo(f)),
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MapTools));
